import React, { useState, useEffect, Fragment, useRef } from 'react'
import {
  Select, Form, Input, Button, Modal,
  Upload, Row, Col, DatePicker, message, InputNumber, Space
} from "antd";
import { LoadingOutlined, PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import HandleButton from "@/components/HandleButton"
import StationApi from '@api/station'
import publicApi from '@api/public'
import Title from '@/components/Title'
import MinTitle from '@/components/MinTitle'
import MessageApi from '@api/message'
import './style.scss'
import moment from 'moment';
const qs = require("query-string");
const { Option } = Select;
const { UPLOADER } = window.globalConfig;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 14 },
};

const tailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

export default (props) => {
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(false)  //文本是否可编辑
  const [searchParams, setSerachParams] = useState({})  //点击编辑设置传过来的站点参数
  const [fileList1, setFileList1] = useState([])
  const [devImg1, setDevImg1] = useState([])
  const [fileList2, setFileList2] = useState([])
  const [devImg2, setDevImg2] = useState([])
  const [title, setTitle] = useState("编辑站点")
  const [isUpload, setUpload] = useState(false) //是否上传
  const [devDetail, setDevDetail] = useState(null) //是否显示上传按钮
  const [previewVisible, setPreviewVisible] = useState(false)  //是否显示点击图片查看的弹框
  const [previewImage, setPreviewImage] = useState("")  //弹框里面的大图
  const [userList, setUserList] = useState([])
  const [ostatus, setOstatus] = useState(0)
  const [video, setVideo] = useState([{ VGW: '', SXT: [{ CCD: '', URL: '' }] }])
  useEffect(() => {
    mathUrl()
    selectWithClassifyKey()
    const tag = getUrlCode("tag");
    setSerachParams({tag})
    return () => { }
  }, [])

  const getUrlCode = (name) => {
    return (
      decodeURIComponent(
        (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
          location.href
        ) || [, ""])[1].replace(/\+/g, "%20")
      ) || null
    );
  }

  const goback = () => {
    props.history.go(-1)
  }
  const children = []
  userList.map((item) => {
    children.push(<Select.Option key={item.id} value={item.realName}>{item.realName}</Select.Option>)
  })

  const addOut = () => {
    video.push({ VGW: '', SXT: [{ CCD: '', URL: '' }] })
    setVideo([...video])
  }
  const removeOut = (params) => {
    video.splice(params, 1);
    setVideo([...video])
  }
  const addInside = (params) => {
    video[params].SXT.push({ CCD: '', URL: '' })
    setVideo([...video])
  }
  const removeInside = (params, oparams) => {
    video[params].SXT.splice(oparams, 1);
    setVideo([...video])
  }
  const outChange = (e, index, iindex, type) => {
    let value = e.target.value;
    let data = video
    if (iindex != undefined) {
      data[index].SXT[iindex][type] = value;
    } else {
      data[index].VGW = value;
    }
    setVideo([...data])
  }
  const Indisabled = (index, iindex) => {
    let a = document.getElementsByClassName(index + ',' + iindex)
    if (a[0].disabled) {
      a[0].disabled = false
      a[1].disabled = false
    } else {
      a[0].disabled = true
      a[1].disabled = true
    }
  }
  const Outdisabled = (index) => {
    let a = document.getElementsByClassName(index + ',')
    if (a[0].disabled) {
      a[0].disabled = false
    } else {
      a[0].disabled = true
    }
  }
  const selectWithClassifyKey = () => {
    MessageApi.userOptionList().then(res => {
      if (res.status == 0) {
        res.data.map((item) => {
          setUserList(res.data)
        })
      }
    })
  }
  //编辑站点进来的页面调用
  const mathUrl = () => {
    let baseData = sessionStorage.getItem('obj') ? JSON.parse(sessionStorage.getItem('obj')) : {}
    let params = qs.parse(props.history.location.search)
    let { name, aliasName, addr, lat, lon, status, iotGatewayNum, serviceTime, construction, comDepart,
      conLeader, conLeaderPho, area, totalBudget, treatProcess, designProc, designSludgeProc, conStartTime,
      conEndTime, conRemark, stationPic, operate, opeDepart, opeLeader, opeLeaderPho, opeStartTime,
      opeRemark, camera, createAt } = baseData
    const newCamera = JSON.parse(camera)
    if (newCamera != null) {
      setVideo(newCamera)
    }

    setOstatus(status)
    const arr = []
    if (opeStartTime) {
      opeStartTime = opeStartTime
    } else {
      const date = new Date();
      const Year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDay();
      opeStartTime = Year + '-' + month + '-' + day
    }


    form.setFieldsValue({
      name: name,
      aliasName: aliasName,
      addr: addr,
      latlon: `${lat},${lon}`,
      status: status,
      iotGatewayNum: iotGatewayNum,
      serviceTime: moment(serviceTime),
      construction: construction,
      comDepart: comDepart,
      conLeader: conLeader,
      conLeaderPho: conLeaderPho,
      area: area,
      totalBudget: totalBudget,
      treatProcess: treatProcess,
      designProc: designProc,
      designSludgeProc: designSludgeProc,
      conStartTime: moment(conStartTime),
      conEndTime: moment(conEndTime),
      conRemark: conRemark,
      stationPic: stationPic,
      operate: operate,
      opeDepart: opeDepart,
      opeLeader: opeLeader ? opeLeader.split(',') : [],
      opeLeaderPho: opeLeaderPho,
      opeStartTime: moment(opeStartTime),
      opeRemark: opeRemark,
    })
    if (stationPic) {
      let devImg1 = stationPic ? stationPic.split(",") : []
      let fileList = [];
      devImg1.length > 0 && devImg1.map((item, index) => {
        let parmar = {
          uid: `-${index}`,
          name: "错误!",
          url: item,
          type: 'image/jpeg'
        };
        fileList.push(parmar);
      });

      setDevImg1(devImg1)
      setFileList1(fileList)
    }
  }


  const btnList = [{
    title: "保存",
    style: {
      background: "#2D99FF",
      color: "white",
      borderRadius: '3px',
      width: "256px",
      height: '40px',
      margin: "12px",
      border: '1px solid #2D99FF'
    },
    onClick: () => {
      saveFrom()
    }
  }]


  //  表单保存  数据提交
  const saveFrom = () => {
    form.validateFields().then(values => {
      let params = qs.parse(props.history.location.search)
      values = {
        ...values,
        id: params.id,
        lat: values.latlon.split(",")[0],
        lon: values.latlon.split(",")[1],
        stationPic: devImg1.join(","),
        opeLeader: values.opeLeader.join(','),
        camera: JSON.stringify(video),
        conEndTime: moment(values.conEndTime).format("YYYY-MM-DD"),
        conStartTime: moment(values.conStartTime).format("YYYY-MM-DD"),
        opeStartTime: moment(values.opeStartTime).format("YYYY-MM-DD")
      }
      StationApi.update({ ...values }).then(res => {
        if (res.status == 0) {
          message.success("更新成功！")
          props.history.push(`/systemSeting/station`)
        }
      })

    })
  }

  const handleCancel = () => {
    setPreviewVisible(false)
  }

  //   图片格式转换
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => reject(error);
    });
  }

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    let img = file.url || file.preview
    setPreviewImage(img)
    setPreviewVisible(true)
  };
  //   判断上传文件格式以及大小
  const beforeUpload = (file) => {
    if ((file.name).includes(",") || (file.name).includes("，")) {
      return message.error("文件名称不能包含特殊字符【，】或【,】")
    }
    let isJPG =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/gif";
    if (!isJPG) {
      return message.error("只能上传图片!");
    } else {
      if (file.size > 5 * 1024 * 1024) {
        return message.error("只能上传5M以内的照片！");
      } else {
        setUpload(true)
      }
    }
    return isJPG;
  }

  /**
 * 界面删除图片时调用
 * @key devImg:存放用户上传图片时服务器返回的图片url
 * @param e :被删除图片的信息
 */
  const onRemovePic = (e, tag) => {
    if (tag == 1) {
      if (e.response) {
        let deleteUrl = e.response.data.url;
        devImg1.length > 0 && devImg1.map((item, index) => {
          if (item == deleteUrl) {
            devImg1.splice(index, 1);
          }
        });
        setDevImg1(devImg1)
      } else {
        let url = e.url;
        devImg1.length > 0 && devImg1.map((item, index) => {
          if (item == url) {
            devImg1.splice(index, 1);
          }
        });
        setDevImg1(devImg1)
      }


      if (devImg1.length < 1) {
        form.setFieldsValue({ stationPic: null })
        setFileList1([])
      }
    }
  }

  //   图片上传与修改
  const handleChange = (imgList, tag) => {
    if (imgList.file.type != "image/jpeg" && imgList.file.type != "image/png" && imgList.file.type != "image/gif") {
      imgList.fileList.pop()
    }
    let length = imgList.fileList.length; //imgList是这个 {event: ProgressEvent, file: {…}, fileList: Array()}
    setFileList1(imgList.fileList)
    if (tag == 1) {
      if (imgList.file.status == "done") { //uploading代表正在上传中
        let newUrl = imgList.file.response.data.url; //imgList.file.response.data.url响应的上传地址
        devImg1.push(newUrl);
        setDevImg1(devImg1)
      }
      if (isUpload || fileList1.length > length) { //放进fileList1的已经上传的图片数组的长度
        setUpload(false)
      }
    }
  };



  const onOk = (obj) => {
    handleCancel()
    form.setFieldsValue({ latlon: `${obj.lat},${obj.lng}` })
  }

  const uploadButton = (
    <div>
      {isUpload ? <LoadingOutlined /> : <PlusOutlined />}
      <div className="ant-upload-text">上传</div>
    </div>
  );

  return (
    <div className='baseContent newStation-page all'>
      <Title title={title} ></Title>
      <div className='content'>
        <Form
          {...layout}
          name="basic"
          form={form}
        >
          <div className='alltitle'><i className='iconfont iconjichuxinxi cc'></i>&nbsp;&nbsp;<MinTitle title="基础信息"></MinTitle></div>
          <Row span={24}>
            <Col span={10}>
              <Form.Item
                label='站点名称'
                name="name"
                rules={[{ required: true, message: '请输入设备名称' }]}
              >
                <Input maxLength={100} placeholder="不超过100个字" />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                label='站点简称'
                name="aliasName"
                rules={[{ required: true, message: '请输入设备简称' }]}
              >
                <Input maxLength={50} placeholder="不超过50个字" />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                label='详细地址'
                name="addr"
                rules={[{ required: true, message: '请输入详细地址' }]}
              >
                <Input disabled maxLength={100} style={{ width: "100%" }} placeholder={'不超过100个字'} />
              </Form.Item>
            </Col>
          </Row>

          <Row span={24}>
            <Col span={10}>
              <Form.Item
                label='经纬度'
                name="latlon"
                rules={[{ required: true, message: '请获取经纬度' }]}
              >
                <Input disabled style={{ width: "100%" }} placeholder={'101.8292191，101.4984944'} />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                label='当前状态'
                name="status"
                rules={[{ required: true, message: '请获取经纬度' }]}
              >
                <span className={ostatus == 0 ? 'greenMark' : ostatus == 1 ? 'redMark' : ostatus == 2 ? 'blueMark' : ''}>
                  {
                    ostatus == 0 ? <i className='iconfont iconzhengchang'>  正常</i> :
                      ostatus == 1 ? <i className='iconfont iconqianfei'>  欠费</i> :
                        ostatus == 2 ? <i className='iconfont icontingyong'>  停用</i> : ''
                  }
                </span>
              </Form.Item>
            </Col>

          </Row>

          <Row span={24}>
            <Col span={10}>
              <Form.Item
                label='物联网网关'
                name="iotGatewayNum"
                rules={[{ required: true, message: '请输入所属河流' }]}
              >
                <Input maxLength={100} disabled style={{ width: "100%" }} placeholder={'不超过100个字'} />
              </Form.Item>
            </Col>

          </Row>


          <div className='alltitle'><i className='iconfont iconyunyingguanlixinxi cc'></i>&nbsp;&nbsp;<MinTitle title="建设信息"></MinTitle></div>
          <Row span={24}>
            <Col span={10}>
              <Form.Item
                label='建设单位'
                name="construction"
                rules={[{ required: true, message: '请输入建设单位' }]}
              >
                <Input maxLength={50} disabled={disabled} style={{ width: "100%" }} placeholder={'不超过50个字'} />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                label='主管部门'
                name="comDepart"
                rules={[{ required: true, message: '请选择主管部门' }]}
              >
                <Input maxLength={50} disabled={disabled} style={{ width: "100%" }} placeholder={'不超过50个字'} />
              </Form.Item>
            </Col>

          </Row>

          <Row span={24}>
            <Col span={10}>
              <Form.Item
                label='建设负责人'
                name="conLeader"
                rules={[{ required: true, message: '请输入建设负责人' }]}
              >
                <Input maxLength={20} disabled={disabled} style={{ width: "100%" }} placeholder={'不超过20个字'} />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                label='联系方式'
                name="conLeaderPho"
                rules={[{
                  required: true,
                  pattern: new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/),
                  message: '请输入正确的联系方式！'
                }]}
              >
                <Input disabled={disabled} style={{ width: "100%" }} placeholder={'请输入建设负责人联系方式'} />
              </Form.Item>
            </Col>
          </Row>

          <Row span={24}>
            <Col span={10}>
              <Form.Item
                label='占地面积'
                name="area"
                rules={[{ required: true, message: '请输入占地面积' }]}
              >
                <InputNumber min={0} disabled={disabled} style={{ width: "100%" }} placeholder={'请输入占地面积'} />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                label='总投资预算'
                name="totalBudget"
                rules={[{ required: true, message: '请输入投资总预算' }]}
              >
                <InputNumber min={0} disabled={disabled} style={{ width: "100%" }} placeholder={'投资总预算'} />
              </Form.Item>
            </Col>
          </Row>

          <Row span={24}>
            <Col span={10}>
              <Form.Item
                label='处理工艺'
                name="treatProcess"
                rules={[{ required: true, message: '请选择处理工艺' }]}
              >
                <Input maxLength={50} disabled={disabled} style={{ width: "100%" }} placeholder={'不超过50个字'} />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                label='设计处理能力'
                name="designProc"
                rules={[{ required: true, message: '请输入设计处理能力' }]}
              >
                <InputNumber min={0} disabled={disabled} style={{ width: "100%" }} placeholder={'请输入设计处理能力'} />
              </Form.Item>
            </Col>
          </Row>

          <Row span={24}>
            <Col span={10}>
              <Form.Item
                label='设计污泥处理能力'
                name="designSludgeProc"
                rules={[{ required: true, message: '请输入设计污泥处理能力' }]}
              >
                <InputNumber min={0} disabled={disabled} style={{ width: "100%" }} placeholder={'请输入设计污泥处理能力'} />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                label='开工时间'
                name="conStartTime"
                rules={[{ required: true, message: '请选择开工时间' }]}
              >
                <DatePicker disabled={disabled} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>

          <Row span={24}>
            <Col span={10}>
              <Form.Item
                label='竣工时间'
                name="conEndTime"
                rules={[{ required: true, message: '请选择竣工时间' }]}
              >
                <DatePicker disabled={disabled} placeholder="请输入竣工时间" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                label='备注'
                name="conRemark"
              >
                <Input.TextArea maxLength={200} disabled={disabled} placeholder={'不超过200个字'} />
              </Form.Item>
            </Col>
          </Row>



          <Fragment>
            <div className='alltitle'><i className='iconfont iconyunyingshuju  cc'></i>&nbsp;&nbsp;<MinTitle title="运营信息"></MinTitle></div>
            <Row span={24}>
              <Col span={10}>
                <Form.Item
                  label='运营单位'
                  name="operate"
                  rules={[{ required: true, message: '请输入运营单位' }]}
                >
                  <Input maxLength={50} disabled={disabled} placeholder={'不超过50个字'} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item
                  label='运营部门'
                  name="opeDepart"
                  rules={[{ required: true, message: '请选择运营部门' }]}
                >
                  <Input maxLength={50} disabled={disabled} placeholder={'不超过50个字'} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>

            <Row span={24}>
              <Col span={10}>
                <Form.Item

                  label='运维负责人'
                  name="opeLeader"
                  rules={[{ required: true, message: '请输入运维负责人' }]}
                >
                  <Select mode="multiple" placeholder="请选择" allowClear>
                    {children}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item
                  label='联系方式'
                  name="opeLeaderPho"
                  rules={[{ required: true, message: '请输入联系方式' }]}
                >
                  <Input disabled={disabled} placeholder={'请输入联系方式'} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>

            <Row span={24}>
              <Col span={10}>
                <Form.Item
                  label='投入运营时间'
                  name="opeStartTime"
                  rules={[{ required: true, message: '请选择运营投入时间' }]}
                >
                  <DatePicker disabled={disabled} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item
                  label='备注'
                  name="opeRemark"
                >
                  <Input.TextArea maxLength={200} disabled={disabled} placeholder={'不超过200个字'} />
                </Form.Item>
              </Col>
            </Row>

            <Row span={24}>
              <Col span={20}>
                <Form.Item
                  name="stationPic"
                  label="站点照片"
                  valuePropName="filelist1"
                  {...tailLayout}
                  extra="最多上传6张站点照片,第一张照片默认为站点主图"
                  rules={[{ required: true, message: '请上传站点照片' }]}
                >
                  <div className="clearfix">
                    <Upload
                      action={UPLOADER}
                      listType="picture-card"
                      fileList={fileList1}
                      onPreview={(file) => handlePreview(file)}  //{/* 	点击文件链接或预览图标时的回调*/}
                      beforeUpload={(file) => beforeUpload(file)}
                      onRemove={(file) => onRemovePic(file, 1)}
                      onChange={(file) => handleChange(file, 1)}
                      disabled={disabled}
                    >
                      {fileList1.length > 5 || devDetail ? null : uploadButton}
                    </Upload>
                    <Modal
                      open={previewVisible}
                      footer={null}
                      onCancel={handleCancel}
                      width="620"
                    >
                      <img
                        alt="加载失败!"
                        style={{ width: "100%", marginTop: "25px" }}
                        src={previewImage}
                      />
                    </Modal>
                  </div>
                </Form.Item>
              </Col>
            </Row>



          </Fragment>

          <div className='alltitle'><i className='iconfont iconshexiangtou cc'></i>&nbsp;&nbsp;<MinTitle title="视频监控设置"></MinTitle></div>
          {


            video.map((item, index) => {
              return (
                <div key={index} style={{ marginTop: ' 40px' }}>
                  <Row span={24} >
                    <Col span={7} offset={2}>
                      <span>视频网关：</span>  <Input className={index + ','} value={item.VGW} onChange={(e) => { outChange(e, index) }} maxLength={100} style={{ width: '206px' }} disabled={disabled} placeholder="不超过100个字" />
                    </Col>
                    <Col>
                      &nbsp;&nbsp;&nbsp;<span onClick={() => { Outdisabled(index) }} style={{ color: '#2D99FF', cursor: 'pointer' }}><i className='iconfont iconbianji cc'></i> 修改</span>
                      &nbsp;&nbsp;
                      {
                        video.length == 1 ? '' : <span style={{ color: '#2D99FF', cursor: 'pointer' }} onClick={() => { removeOut(index) }}><i className='iconfont iconshanchu cc'></i> 删除</span>
                      }
                      &nbsp;&nbsp;
                      {
                        index == video.length - 1 && <span style={{ color: '#2D99FF', cursor: 'pointer' }} onClick={addOut}><i className='iconfont iconfangda cc'></i> 添加</span>
                      }
                    </Col>
                  </Row>
                  {
                    item.SXT.map((aitem, iindex) => {
                      return (
                        <Row span={24} key={iindex} style={{ marginTop: ' 20px' }}>
                          <Col span={7} offset={2}>
                            <span>摄像头{iindex + 1}：</span>&nbsp;&nbsp;&nbsp;<Input className={index + ',' + iindex} style={{ width: '206px' }} value={aitem.CCD} onChange={(e) => { outChange(e, index, iindex, 'CCD') }} placeholder="请输入非中文" />
                          </Col>
                          <Col span={10}>
                            <span>URL：</span>     <Input className={index + ',' + iindex} style={{ width: '330px' }} value={aitem.URL} onChange={(e) => { outChange(e, index, iindex, 'URL') }} placeholder="不超过100个字" />
                          </Col>
                          <Col span={5}>
                            &nbsp;&nbsp;&nbsp;<span onClick={() => { Indisabled(index, iindex) }} style={{ color: '#2D99FF', cursor: 'pointer' }}><i className='iconfont iconbianji cc'></i> 修改</span>
                            &nbsp;&nbsp;
                            {
                              iindex == 0 && item.SXT.length == 1 ? '' : <span style={{ color: '#2D99FF', cursor: 'pointer' }} onClick={() => { removeInside(index, iindex) }}><i className='iconfont iconshanchu cc'></i> 删除</span>
                            }
                            &nbsp;&nbsp;
                            {
                              iindex == item.SXT.length - 1 && <span style={{ color: '#2D99FF', cursor: 'pointer' }} onClick={() => { addInside(index) }}><i className='iconfont iconfangda cc'></i> 添加</span>
                            }
                          </Col>
                        </Row>
                      )
                    })
                  }
                </div>
              )
            })

          }
        </Form>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Button style={{ top: '0', marginLeft: '20px' }} onClick={goback}><i className='iconfont iconfanhui'></i>&nbsp;&nbsp;取消</Button>
        {searchParams.tag != "detail" && <Button style={{ marginLeft: 20 }} type='primary' onClick={saveFrom}>保存</Button>}
      </div>
    </div >
  )
}
